
    // Import the main app module
    // In Docker, use simple import without timestamp for better compatibility
    if (typeof window !== 'undefined') {
      window.__BUILD_TS__ = Date.now();
    }
    import('./src/core/app.js?v=20260804-safety3');
  